<template>
  <div class="excellent-capabilities-instructions">
    <common-bg-plate>
      <detail-section title="如何使用增强能力">
        <div class="instructions-info">
          <div class="instructions-content">
            <template v-for="(item, index) in steps">
              <div :key="index" class="instructions-item">
                <div class="instructions-icon">
                  <img :src="item.icon" alt="" />
                </div>
                <div class="instructions-text">{{ item.title }}</div>
              </div>
              <div
                v-if="index < steps.length - 1"
                :key="`vector${index}`"
                class="instructions-vector"
              >
                <div class="instructions-vector-icon"></div>
              </div>
            </template>
          </div>
          <div class="instructions-btns">
            <btn-style :btn-list="btnList"></btn-style>
          </div>
          <div class="instructions-doc">
            <span>部署详情，详见</span>
            <router-link class="doc-link" to="/excellent/deploymentManual"
              >部署说明文档</router-link
            >
          </div>
        </div>
      </detail-section>
      <download-dialog
        ref="downloadDialog"
        title="下载增强能力部署包"
        :file-name="downloadFileName"
        :file-url="downloadFileUrl"
        :dialog-visible.sync="showDownloadDialog"
      ></download-dialog>
    </common-bg-plate>
  </div>
</template>

<script>
import downloadDialog from './downloadDialog'
import stepSelectiveAbilityIcon from '@/assets/images/excellent/step-selective-ability-icon.png'
import stepDeployIcon from '@/assets/images/excellent/step-deployment-icon.png'
import stepConfigIcon from '@/assets/images/excellent/step-config-icon.png'
import stepTestIcon from '@/assets/images/excellent/step-test-icon.png'
import stepResDownloadIcon from '@/assets/images/excellent/step-res-download-icon.png'

export default {
  name: 'Instructions',
  components: {
    downloadDialog
  },
  data() {
    return {
      btnList: [
        {
          btnContent: '下载部署包',
          click: () => {
            return this.downloadDeploymentPackage()
          },
          icon: 'icon-download'
        }
      ],
      steps: [
        {
          title: '选择要部署的能力',
          icon: stepSelectiveAbilityIcon
        },
        {
          title: '资源下载',
          icon: stepResDownloadIcon
        },
        {
          title: '安装部署',
          icon: stepDeployIcon
        },
        {
          title: '添加服务器配置',
          icon: stepConfigIcon
        },
        {
          title: '调用测试',
          icon: stepTestIcon
        }
      ],
      //下载对话框
      showDownloadDialog: false,
      downloadFileName: 'excellent-capabilities-deployment-package.zip',
      downloadFileUrl: '/cbaas-service/v1/extra/encryptSvrDownload'
    }
  },
  methods: {
    downloadDeploymentPackage() {
      this.showDownloadDialog = true
    },
    seeDeploymentDoc() {
      this.$router.push({
        name: 'deploymentManual'
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'excellent-capabilities-instructions',
  (
    --instructions-vector-image: url('~@/assets/images/excellent/small-vector-dark.png'),
    --excellent-capabilities-instructions-color: #ffffff,
    --excellent-capabilities-instructions-background-color: #354274,
    --excellent-capabilities-instructions-content-doc-color: #ffffff,
    --excellent-capabilities-instructions-content-doc-link-color: #45c2ff
  ),
  (
    --instructions-vector-image: url('~@/assets/images/excellent/small-vector-light.png'),
    --excellent-capabilities-instructions-color: #192227,
    --excellent-capabilities-instructions-background-color: #f6f7f9,
    --excellent-capabilities-instructions-content-doc-color: #192227,
    --excellent-capabilities-instructions-content-doc-link-color: #45c2ff
  )
);
.excellent-capabilities-instructions {
  @include adaptation(
    (
      --excellent-capabilities-instructions-height: 353px,
      --excellent-capabilities-instructions-content-margin-top: 8px,
      --excellent-capabilities-instructions-content-margin-padding: 0 84px,
      --excellent-capabilities-instructions-content-item-width: 96px,
      --excellent-capabilities-instructions-content-item-icon-size: 96px,
      --excellent-capabilities-instructions-content-item-margin-bottom: 29px,
      --excellent-capabilities-instructions-content-item-padding: 20px,
      --excellent-capabilities-instructions-content-item-icon-img-size: 42px,
      --excellent-capabilities-instructions-content-font-size: 18px,
      --excellent-capabilities-instructions-content-line-height: 26px,
      --excellent-capabilities-instructions-content-vector-margin-top: 40px,
      --excellent-capabilities-instructions-content-vector-height: 16px,
      --excellent-capabilities-instructions-content-vector-line-height: 2px,
      --excellent-capabilities-instructions-content-vector-line-margin-left: -8px,
      --excellent-capabilities-instructions-content-vector-line-margin-right: -8px,
      --excellent-capabilities-instructions-btns-margin-top: 40px,
      --excellent-capabilities-instructions-btns-margin-bottom: 12px,
      --excellent-capabilities-instructions-content-vector-font-size: 16px,
      --excellent-capabilities-instructions-content-doc-font-size: 12px,
      --excellent-capabilities-instructions-content-doc-line-height: 17px
    )
  );
  .common-bg-plate {
    min-height: var(--excellent-capabilities-instructions-height);
    height: var(--excellent-capabilities-instructions-height);

    .instructions-content {
      display: flex;
      justify-content: space-between;
      margin-top: var(--excellent-capabilities-instructions-content-margin-top);
      padding: var(--excellent-capabilities-instructions-content-margin-padding);

      .instructions-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: var(--excellent-capabilities-instructions-color);
        width: var(--excellent-capabilities-instructions-content-item-width);

        .instructions-icon {
          width: var(--excellent-capabilities-instructions-content-item-icon-size);
          height: var(--excellent-capabilities-instructions-content-item-icon-size);
          background-color: var(--excellent-capabilities-instructions-background-color);
          border-radius: 50%;
          margin-bottom: var(--excellent-capabilities-instructions-content-item-margin-bottom);
          padding: var(--excellent-capabilities-instructions-content-item-padding);
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;

          & img {
            width: var(--excellent-capabilities-instructions-content-item-icon-img-size);
            height: var(--excellent-capabilities-instructions-content-item-icon-img-size);
          }
        }

        .instructions-text {
          font-size: var(--excellent-capabilities-instructions-content-font-size);
          font-weight: 500;
          height: var(--excellent-capabilities-instructions-content-line-height);
          line-height: var(--excellent-capabilities-instructions-content-line-height);
          white-space: nowrap;
        }
      }

      .instructions-vector {
        width: 100%;
        margin-top: var(--excellent-capabilities-instructions-content-vector-margin-top);
        position: relative;
        display: flex;
        height: var(--excellent-capabilities-instructions-content-vector-height);
        align-items: center;
        color: var(--excellent-capabilities-instructions-background-color);

        .instructions-vector-icon {
          background-image: var(--instructions-vector-image);
          background-size: 100% 100%;
          width: var(--base-size-16);
          height: var(--base-size-16);
          left: calc(50% - var(--base-size-8));
          position: absolute;
          z-index: 1;
        }

        &::before,
        &::after {
          height: var(--excellent-capabilities-instructions-content-vector-line-height);
          width: 100%;
          background-color: var(--excellent-capabilities-instructions-background-color);
          content: '';
          margin-left: var(--excellent-capabilities-instructions-content-vector-line-margin-left);
          margin-right: var(--excellent-capabilities-instructions-content-vector-line-margin-right);
        }
      }
    }

    .instructions-btns {
      margin-top: var(--excellent-capabilities-instructions-btns-margin-top);
      margin-bottom: var(--excellent-capabilities-instructions-btns-margin-bottom);

      .cbaas-btn-style {
        justify-content: center;
      }
    }

    .instructions-doc {
      color: var(--excellent-capabilities-instructions-content-doc-color);
      font-size: var(--excellent-capabilities-instructions-content-doc-font-size);
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: var(--excellent-capabilities-instructions-content-doc-line-height);

      .doc-link {
        color: var(--excellent-capabilities-instructions-content-doc-link-color);
      }
    }
  }
}
</style>
